var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownLoadScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.1571L3.44229 6.59937L4.32063 5.69563L6.375 7.75V0.75H7.625V7.75L9.67937 5.69563L10.5577 6.59937L7 10.1571ZM2.25646 13.25C1.83549 13.25 1.47917 13.1042 1.1875 12.8125C0.895833 12.5208 0.75 12.1645 0.75 11.7435V9.48396H2V11.7435C2 11.8077 2.02674 11.8665 2.08021 11.9198C2.13354 11.9733 2.19229 12 2.25646 12H11.7435C11.8077 12 11.8665 11.9733 11.9198 11.9198C11.9733 11.8665 12 11.8077 12 11.7435V9.48396H13.25V11.7435C13.25 12.1645 13.1042 12.5208 12.8125 12.8125C12.5208 13.1042 12.1645 13.25 11.7435 13.25H2.25646Z",
    fill: "#3474E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownLoadScore);
export default __webpack_public_path__ + "static/media/DownLoadScore.82b7a8fac37ef298da16d66547a943e8.svg";
export { ForwardRef as ReactComponent };